var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import http from 'app/services/http';
export const TASKS_PAGE_SIZE = 30;
function readTasksPage(body, requestedPage) {
    if (Array.isArray(body)) {
        return {
            items: body,
            page: 1,
            total: body.length,
            totalPages: 1,
        };
    }
    const record = body && typeof body === 'object' ? body : {};
    const items = Array.isArray(record.data) ? record.data : [];
    const total = Number(record.total);
    const page = Number(record.page);
    const totalPages = Number(record.totalPages);
    const safeTotal = Number.isFinite(total) ? total : items.length;
    const safeTotalPages = Number.isFinite(totalPages) && totalPages > 0 ? totalPages : Math.max(1, Math.ceil(safeTotal / TASKS_PAGE_SIZE));
    return {
        items,
        page: Number.isFinite(page) && page > 0 ? page : requestedPage,
        total: safeTotal,
        totalPages: safeTotalPages,
    };
}
export function taskLoad(page = 1) {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        const requestedPage = Number.isFinite(page) && page > 0 ? Math.floor(page) : 1;
        dispatch({ type: 'TASK_LOADING' });
        try {
            const response = yield http.get('/report/tasks', {
                params: { page: requestedPage, limit: TASKS_PAGE_SIZE },
            });
            const tasksPage = readTasksPage(response.data, requestedPage);
            if (requestedPage > tasksPage.totalPages) {
                return dispatch(taskLoad(tasksPage.totalPages));
            }
            dispatch({ type: 'TASK_SET_ITEMS', payload: tasksPage });
        }
        catch (error) {
            console.error('Failed to load tasks', error);
            dispatch({
                type: 'TASK_SET_ITEMS',
                payload: { items: [], page: 1, total: 0, totalPages: 1 },
            });
        }
    });
}
